import store from 'store';

export const deleteItem = (props) => {
  if (!(props && props.item)) return false;

  const {
    connectors,
    deleteConnectorRequest,
    removeItemRequest,
    removeVoiceItemRequest,
    removeItemsOnError,
  } = props;
  console.log(`deleteItem = connector: ${connectors}`);
  if (props.item.type === `Menu` || props.item.type === `MenuAI`) {
    // Recupero os menusItens do bloco de menu //
    const { menuItems } = props.item;
    // para cada menuitem, recupero os conectores que ele eh pai
    menuItems.forEach((menuItem) => {
      const connectorMenuItems = connectors.filter(
        (connector) => connector.from === menuItem._id
      );

      connectorMenuItems.forEach((connectorItem) => {
        console.log(`DeleteItem - connectorItemId: ${connectorItem._id}`);
        deleteConnectorRequest(connectorItem._id, props.bot._id);
      });
    });
  }

  if (props.item.type === `Conditional`) {
    // Recupero os menusItens do bloco de menu //
    const { conditions } = props.item;
    // para cada menuitem, recupero os conectores que ele eh pai
    conditions.forEach((condition) => {
      const connectorConditions = connectors.filter(
        (connector) => connector.from === condition._id
      );

      connectorConditions.forEach((connectorItem) => {
        console.log(`DeleteItem - connectorConditions: ${connectorItem._id}`);
        deleteConnectorRequest(connectorItem._id, props.bot._id);
      });
    });
  }
  const connectorsItem = connectors.filter(
    (connector) =>
      connector.from === props.item._id || connector.to === props.item._id
  );

  connectorsItem.forEach((connector) => {
    console.log(`DeleteItem - connectorId: ${connector._id}`);
    deleteConnectorRequest(connector._id, props.bot._id);
  });

  const isVoiceItem = props.item.type?.startsWith('Voice');

  if (isVoiceItem) {
    removeVoiceItemRequest(props.item);
  } else {
    removeItemRequest(props.item);
  }
  removeItemsOnError(props.item._id);

  const toast = document.getElementById('toast-notification');
  toast.classList.remove('is-showing');
  toast.removeChild(toast.children[0]);
  const message = document.createElement('span');
  message.innerText = 'Item apagado';
  toast.appendChild(message);
  toast.classList.add('is-showing');
  setTimeout(() => {
    toast.classList.remove('is-showing');
  }, 1000);
};

export const deleteConnector = (props) => {
  const { deleteConnectorRequest, setCurrentPath, editItem } = props;

  deleteConnectorRequest(props.path._id, props.bot._id);

  const fromItem = props.items.find(
    (item) => item._id === props.path?.from && item.type === 'Conditional'
  );
  if (fromItem)
    store.dispatch(editItem({ ...fromItem, ...{ conditionEscape: '' } }));

  const toast = document.getElementById('toast-notification');
  toast.classList.remove('is-showing');
  toast.removeChild(toast.children[0]);
  const message = document.createElement('span');
  message.innerText = 'Ligação apagada';
  toast.appendChild(message);
  toast.classList.add('is-showing');
  setTimeout(() => {
    toast.classList.remove('is-showing');
  }, 1000);

  setCurrentPath(null);
};
